import {
  enableCustomerContract,
  disableCustomerContract
} from 'src/app/queries/queries'

const enableUserContract = (input, success, error) => {
  return {
    type: 'API:ENABLECUSTOMERCONTRACT',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: enableCustomerContract,
      variables: {
        input: input
      }
    }
  }
}

const disableUserContract = (input, success, error) => {
  return {
    type: 'API:DISABLECUSTOMERCONTRACT',
    API: true,
    method: 'POST',
    url: '/api/query',
    success,
    error,
    data: {
      query: disableCustomerContract,
      variables: {
        input: input
      }
    }
  }
}

export default {
  enableUserContract,
  disableUserContract
}
